var render = function render(_c, _vm) {
  return _c(
    "div",
    { staticClass: "message with-icon" },
    [
      _c("font-awesome-icon", {
        staticClass: "decorative",
        attrs: { icon: _vm.parent.$v6.solid.faFileCertificate },
      }),
      _vm._v("\n  Using Font Awesome Free?\n  "),
      _c(
        "site-link",
        {
          staticClass: "margin-left-xs",
          attrs: { to: { name: "license.free" } },
        },
        [_vm._v("\n    View the Font Awesome Free License!\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }